import type { Order } from "./order";
import { orderType } from "./order-type";

const isOrder = (item: { _type: unknown }): item is Order => {
    if (item._type === "ORDER" || item._type === "ORDER_PROJECTION")
        return true;
    return false;
};

const orderHasBuyable = (order: Order) => {
    return (
        typeof order.type === "undefined" ||
        order.type === orderType.BUYABLE ||
        order.orderItems.some(item => item.acquireType === "BUYABLE")
    );
};

const orderHasBookable = (order: Order) => {
    return (
        order.type === orderType.BOOKABLE ||
        order.orderItems.some(item => item.acquireType === "BOOKABLE")
    );
};

const orderHasVoucher = (order: Order) => {
    return (
        order.type === orderType.VOUCHER ||
        order.orderItems.some(item => item.acquireType === "VOUCHER")
    );
};
const orderHasGiftCard = (order: Order) => {
    return (
        order.type === orderType.VOUCHER ||
        order.orderItems.some(item => item.acquireType === "GIFTCARD")
    );
};

const orderHasAccommodation = (order: Order) => {
    return (
        order.type === orderType.ACCOMMODATION ||
        order.orderItems.some(item => item.acquireType === "ACCOMMODATION")
    );
};

const isOrderTypeMixed = (order: Order) => {
    return (
        order.type === orderType.MIXED ||
        order.orderItems.some(
            item => item.acquireType !== order.orderItems[0]?.acquireType,
        )
    );
};

export {
    isOrder,
    isOrderTypeMixed,
    orderHasAccommodation,
    orderHasBookable,
    orderHasBuyable,
    orderHasGiftCard,
    orderHasVoucher,
};
